"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementValidatorUtil = void 0;
const DOM_1 = require("../DOM");
class ElementValidatorUtil {
    static getValidationParams(element) {
        const rules = element.attributes.getNamedItem("data-nette-rules");
        const rulesDecoded = rules !== null ? JSON.parse(rules.value) : [];
        const params = { regexes: [] };
        rulesDecoded.forEach((validation) => {
            const validationMsg = validation.msg ? validation.msg : null;
            if (validation.op && validation.op === ":pattern" && validation.arg) {
                params.regexes.push({ regex: new RegExp(validation.arg), problem: validationMsg });
            }
            else if (validation.op && validation.op === ":minLength" && validation.arg) {
                params.minLength = { length: parseInt(validation.arg), problem: validationMsg };
            }
            else if (validation.op && validation.op === ":customMaxLength" && validation.arg) {
                params.customMaxLength = { length: parseInt(validation.arg), problem: validationMsg };
            }
            else if (validation.op && validation.op === ":oneOff" && validation.arg) {
                params.filledOneOf = { inputNames: validation.arg, problem: validationMsg };
            }
            else if (validation.op && validation.op === ":filled") {
                params.filled = { filled: true, problem: validationMsg };
            }
            else if (validation.op && validation.op === ":email") {
                params.email = { email: true, problem: validationMsg };
            }
            else if (validation.op && validation.op === ":equal" && validation.arg && validation.arg.control) {
                params.equalControlName = { name: validation.arg.control, problem: validationMsg };
            }
            else if (validation.op && validation.op === ":fileSize" && validation.arg) {
                params.maxFileSize = { maxSize: parseInt(validation.arg), problem: validationMsg };
            }
            else if (validation.op && validation.op === ":max" && validation.arg) {
                params.maxNumber = { max: parseInt(validation.arg), problem: validationMsg };
            }
            else if (validation.op && validation.op === ":min" && validation.arg) {
                params.minNumber = { min: parseInt(validation.arg), problem: validationMsg };
            }
            else if (validation.op && validation.op === ":dnsValidation" && validation.arg && validation.arg.PATTERNS && validation.arg.TYPE_INPUT_NAME) {
                params.dnsValidation = { patterns: validation.arg.PATTERNS, typeInputName: validation.arg.TYPE_INPUT_NAME, problem: validationMsg };
            }
            else if (validation.op && validation.op === ":stringValidation" && validation.arg) {
                params.stringValidation = { patternType: validation.arg, problem: validationMsg };
            }
            else if (validation.op && validation.op === ":revalidate" && validation.arg) {
                params.revalidate = { nameList: validation.arg };
            }
            else if (validation.op && validation.op === ":string1CnameASameValidation" && validation.arg) {
                params.string1CnameASameValidation = { typeInputName: validation.arg.TYPE_INPUT_NAME, problem: validationMsg };
            }
            else if (validation.op && validation.op === ":date" && validation.arg) {
                params.date = { onlyFuture: validation.arg.onlyFuture, problem: validationMsg };
            }
        });
        return params;
    }
    static updateHelpElement(element, text, valid) {
        if (text === null) {
            return;
        }
        let parentElement = element.parentElement;
        if (!parentElement || !parentElement.classList.contains('customDesign-forms-field')) {
            parentElement = parentElement?.parentElement;
        }
        if (!parentElement || !parentElement.classList.contains('customDesign-forms-field')) {
            parentElement = parentElement?.parentElement;
        }
        if (!parentElement || !parentElement.classList.contains('customDesign-forms-field')) {
            return;
        }
        const foundAlreadyCreatedElements = parentElement.getElementsByClassName('inputInvalidHelp');
        if (foundAlreadyCreatedElements.length > 0 && (element.dataset.filled === 'no' || element.dataset.valid === 'true')) {
            for (let i = 0; i < foundAlreadyCreatedElements.length; i++) {
                parentElement.removeChild(foundAlreadyCreatedElements[i]);
            }
            return;
        }
        else if (element.dataset.filled === 'no' || element.dataset.valid === 'true' || valid) {
            return;
        }
        if (foundAlreadyCreatedElements.length > 0) {
            const alreadyCreatedElement = foundAlreadyCreatedElements[0];
            const textElement = DOM_1.DOM.Parser.getHtmlElementByClass('text', alreadyCreatedElement);
            textElement.innerText = text;
            return;
        }
        const textElement = document.createElement('div');
        textElement.classList.add('inputInvalidHelp-container-text', 'text');
        textElement.innerText = text;
        const arrowInsideElement = document.createElement('div');
        arrowInsideElement.classList.add('inputInvalidHelp-container-arrow-inside');
        const arrowElement = document.createElement('div');
        arrowElement.classList.add('inputInvalidHelp-container-arrow', 'arrow');
        arrowElement.append(arrowInsideElement);
        const containerElement = document.createElement('div');
        containerElement.classList.add('inputInvalidHelp-container');
        const finalElement = document.createElement('div');
        finalElement.classList.add('inputInvalidHelp');
        parentElement.appendChild(finalElement).appendChild(containerElement).append(textElement, arrowElement);
    }
    static initializeShowPasswordButton(element) {
        if (element.type !== 'password' || element.parentElement === null) {
            return;
        }
        const toggleElements = element.parentElement.getElementsByClassName('input-field-password-show');
        if (toggleElements.length === 0) {
            return;
        }
        const trigger = toggleElements[0];
        trigger.addEventListener('click', () => {
            const isHidden = DOM_1.DOM.Parser.getDataByNameFromElement('toggled', trigger) === 'password';
            trigger.dataset.toggled = isHidden ? 'text' : 'password';
            element.setAttribute('type', isHidden ? 'text' : 'password');
            DOM_1.DOM.Parser.getHtmlElementByQuery(`[data-toggle='${!isHidden ? 'password' : 'text'}']`, trigger).style.display = 'block';
            DOM_1.DOM.Parser.getHtmlElementByQuery(`[data-toggle='${isHidden ? 'password' : 'text'}']`, trigger).style.display = 'none';
        });
    }
    static triggerElementValidateNumberOnKey(element) {
        element.addEventListener("keydown", (event) => {
            if (Number.isNaN(event.key)) {
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
            return true;
        });
    }
    static setElementCanDisplayErrors(element) {
        const parentElement = element.closest('.customDesign-forms-field');
        if (parentElement === null)
            return;
        parentElement.classList.add('customDesign-forms-field-displayErrors');
    }
}
exports.ElementValidatorUtil = ElementValidatorUtil;
